
  import { SmartBannerConfig } from './index'
  export const config: SmartBannerConfig = {
    festivalName: 'Le Gueulard Plus',
    appTitle: 'Le Gueulard Plus',
    appStoreId: '0',
    appleStoreUrl: 'https://apps.apple.com/fr/app/le-gueulard-plus/id6751336978',
    googleStoreUrl: 'https://play.google.com/store/apps/details?id=to.chapi.legueulardplus&hl=ln',
    appIconUrl: 'https://static.legueulardplus.chapi.to/app-icon.jpeg',
  }
